<template>
  <v-bottom-navigation
    app
    grow
    hide-on-scroll
    height="66"
    class="align-center"
    color="primary"
    :value="value"
  >
    <v-btn
      v-for="item in navigationItems"
      class="pb-4 pt-2"
      :key="item.id"
      :value="item.id"
      icon
      @click="onChange(item)"
    >
      <span style="font-size: 0.8em; letter-spacing: 0px" class="mt-1">
        {{ item.text }}
      </span>
      <v-icon class="mt-2">{{ item.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script setup lang="ts">
import { navigationItems } from "@/config/navigation";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";

const value = ref("schedules");

const vueInstance = getCurrentInstance();

const currentRoute = computed(() => {
  return vueInstance?.proxy.$route.name ?? "";
});

function onChange(value: { to: { name: string } }) {
  // check current route is same
  if (currentRoute.value === value.to.name) return;
  // navigate to the route
  vueInstance?.proxy.$router.push({ name: value.to.name });
}

function syncCurrentRoute(routeName: string) {
  // set value according to current route
  const relatedRoute = navigationItems.find(
    (item) => item.to.name === routeName,
  );
  if (!relatedRoute) return;
  value.value = relatedRoute.id;
}

watch(currentRoute, (value) => {
  syncCurrentRoute(value);
});

onMounted(() => {
  syncCurrentRoute(currentRoute.value);
});
</script>
